import { IPermissionAction } from "@/models";
import { usePermissions } from "@/features/auth/store/usePermissions.store";

export type PermissionCheckTo = IPermissionAction[] | IPermissionAction;

export type PermissionCheck = {
  must?: PermissionCheckTo;
  mustAdmin?: boolean;
  exhaustive?: boolean;
  negate?: boolean;
};

export const usePermissionCheck = ({
  must,
  mustAdmin,
  negate,
  exhaustive = true,
}: PermissionCheck): boolean => {
  let result = false;

  const isAdmin = usePermissions((state) => state.isAdmin);
  const isAllowedTo = usePermissions((state) => state.isAllowedTo);

  if (typeof mustAdmin !== "undefined") {
    result = mustAdmin && isAdmin;
  } else if (typeof must !== "undefined") {
    const permissions = Array.isArray(must) ? must : [must];
    result = isAllowedTo(permissions, exhaustive);
  }

  if (negate) {
    return !result;
  }

  return result;
};
